<template>

  <div class='Box'>
    <el-card class="box-card">

      <!-- 查询条件 -->
      <el-form :model="queryParams" size="medium" label-width="120px">
        <el-row :gutter="35">
          <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6" class="mb20">
            <el-form-item label="小说名称">
              <el-input v-model="queryParams.name" @change="search" @clear="search" placeholder="请输入小说名称"
                clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="12" :md="12" :lg="7" :xl="6" class="mb20">
            <div class="btn_left">
              <el-button size="medium" type="primary" @click="search">查询</el-button>
              <el-button size="medium" @click="reset">重置</el-button>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12" :md="8" :lg="7" :xl="6" class="mb20">
            <el-form-item label="去掉这个用跳转方式登录,回车搜索会刷新整个页面" hidden>
              <el-select v-model="queryParams.status" @change="search" @clear="search" placeholder="请选择连载状态" clearable
                class="w100">
                <el-option label="测试" value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          
        </el-row>


      </el-form>
      <!--工具栏 -->
      <div class="div_buttom">
        <el-button size="medium" @click="getList">刷新列表</el-button>
        <!--        <el-button size="medium" type="primary" icon="el-icon-upload2">导出</el-button>-->
        <!--        <el-button size="medium" type="primary" icon="el-icon-search" @click="addSearch">打开搜索</el-button>-->
      </div>
      <!-- 列表 -->
      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" size="medium"
        :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }" :cell-style="{ textAlign: 'center' }"
        @selection-change="handleSelectionChange" border @sort-change="sortChange"
        :default-sort="{ prop: 'today_recharge_money', order: 'descending' }" v-loading="loading">
        <el-table-column label="小说ID" width="80">
          <template slot-scope="scope">{{ scope.row.movie_id }}</template>
        </el-table-column>
        <el-table-column prop="name" label="小说名称" min-width="160">
          <template slot-scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="today_recharge_user" label="今日充值人数" width="160" sortable="custom">
          <template slot-scope="scope">{{
            scope.row.today_recharge_user ? scope.row.today_recharge_user : 0
          }}
          </template>
        </el-table-column>
        <el-table-column prop="today_recharge_money" label="今日充值金额" width="160" sortable="custom">
          <template slot-scope="scope">{{
            scope.row.today_recharge_money ? scope.row.today_recharge_money : 0
          }}
          </template>
        </el-table-column>
        <el-table-column prop="today_recharge_num" label="今日充值笔数" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.today_recharge_num ? scope.row.today_recharge_num : 0 }}</template>
        </el-table-column>
        <el-table-column prop="yesterday_recharge_user" label="昨日充值人数" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.yesterday_recharge_user ? scope.row.yesterday_recharge_user : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="yesterday_recharge_money" label="昨日充值金额" width="160" sortable="custom">
          <template slot-scope="scope">
            {{ scope.row.yesterday_recharge_money ? scope.row.yesterday_recharge_money : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="yesterday_recharge_num" label="昨日充值笔数" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.yesterday_recharge_num ? scope.row.yesterday_recharge_num : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="recharge_money" label="总充值金额" width="160" sortable="custom">
          <template slot-scope="scope">{{ scope.row.recharge_money ? scope.row.recharge_money : 0 }}</template>
        </el-table-column>
        <el-table-column prop="recharge_num" label="总充值笔数" sortable="custom" width="160">
          <template slot-scope="scope">{{ scope.row.recharge_num ? scope.row.recharge_num : 0 }}</template>
        </el-table-column>

        <el-table-column fixed="right" label="详情" width="120">
          <template slot-scope="scope">
            <el-button type="text" size="medium" @click="handleViewAnalysis(scope.row)">观看分析</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页组件 -->
      <pagination v-show="total > 0" :total="total" :page.sync="queryParams.pageNo" :limit.sync="queryParams.pageSize"
        @pagination="getList" />

      <el-drawer :wrapperClosable="true" :title="viewTitle" :visible.sync="drawer" size="50%">
        <el-card>
          <div class="btn">
            <el-button size="medium" type="primary" icon="el-icon-download" @click="exportExcel">导出</el-button>
          </div>

          <el-table ref="multipleTable" :data="viewTableData" tooltip-effect="dark" class="tableBox" size="medium"
            :header-cell-style="{ textAlign: 'center', background: '#f5f7fa' }" :cell-style="{ textAlign: 'center' }"
            border  :max-height="tableHeight" v-loading="viewLoading" style="overflow: hidden;">
            <el-table-column v-for="(_, key) in viewTableData[0]" :key="key" :prop="key" :label="key" width="auto">
            </el-table-column>
          </el-table>
        </el-card>
      </el-drawer>
    </el-card>
  </div>


</template>

<script>
import { movieStatisticsApi } from '@/api/statistics/movieSatistics/index';
import { userApi } from "@/api/user";
import { processErrors } from "@/utils/errorHandler";
import { Session } from "@/utils/storage";

export default {
  components: {},
  data() {
    return {
      // 表单标题
      title: "",
      // 表单
      form: {},
      // 表单宽度
      formLabelWidth: "140px",
      // 控制搜索显示
      SearchFlag: true,
      // 查询条件
      queryParams: {
        sortField: "today_recharge_money",
        sortOrder: "desc",
        pageNo: 1,
        pageSize: 10
      },
      // 总条数
      total: 0,
      // 列表数据
      tableData: [],
      multipleSelection: [],
      // 校验规则
      rules: {},
      drawer: false,
      viewTableData: [],
      viewLoading: false,
      maxHeight: 0,
      viewTitle: "观看分析",
      movie_id: "",
      loading: false,
      isRemoveAllTag: 0,
      maxHeight: 600, // 最大高度
    };
  },
  created() {
    this.getList()
  },
  computed: {
    tableHeight() {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1900) {
        return 750; // 大屏（宽度 >= 1900px）设置表格高度为 500px
      } else {
        return 400; // 小屏（宽度 < 1900px）设置表格高度为 400px
      }
    }
  },
  methods: {
    handleResize() {
      // 这里可以添加其他处理逻辑
      this.$forceUpdate(); // 强制刷新组件，以确保计算属性生效
    },
    sortChange(prop) {
      if (prop.order) {
        this.queryParams.sortField = prop.prop
        if (prop.order === 'ascending') {
          this.queryParams.sortOrder = 'asc'
        } else {
          this.queryParams.sortOrder = 'desc'
        }
      } else {
        this.queryParams.sortField = 'today_recharge_money'
        this.queryParams.sortOrder = 'desc'
      }
      this.getList();
    },
    // 获取列表
    getList() {
      this.loading = true
      let api = movieStatisticsApi();
      api.moviesCollectRankingList(this.queryParams).then(res => {
        if (res.code == 0) {
          this.tableData = res.data.data
          this.total = res.data.totalCount
        } else {
          processErrors(res);
        }
        this.loading = false
      })

    },
    // 点击查询
    search() {
      this.queryParams.pageNo = 1;
      this.getList();
    },

    // 重置按钮
    reset() {
      this.queryParams = {
        pageNo: 1,
        pageSize: 10
      }
      this.getList();
    },
    // 搜索开关
    addSearch() {
      this.SearchFlag = !this.SearchFlag
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    handleViewAnalysis(movie) {
      this.movie_id = movie.movie_id;
      this.setMaxHeight();
      window.addEventListener('resize', this.setMaxHeight);
      this.viewTitle = movie.name + '-' + "观看分析";
      this.drawer = true;
      this.viewLoading = true;
      let api = userApi();
      this.viewTableData = [];
      let params = {
        movie_id: movie.movie_id
      }
      api.getViewAnalysis(params).then(res => {
        if (res.code == 0) {
          this.viewTableData = res.data
        } else {
          processErrors(res);
        }
        this.viewLoading = false;
      }).catch(error => {
        console.error('Error fetching user data:', error);
        this.viewLoading = false;
      });
    },

    setMaxHeight() {
      // 获取视口高度
      const viewportHeight = window.innerHeight;

      // 根据需求计算 max-height 的值
      // 例如, 视口高度的 80%
      this.maxHeight = viewportHeight * 0.93;
    },

    exportExcel() {
      const urlParams = new URLSearchParams();
      urlParams.append('movie_id', this.movie_id)
      let url = new URL(window.location.href);
      let token = url.searchParams.get('token');
      if (token !== null) {
        urlParams.append('token', token)
      } else if (Session.get('token')) {
        urlParams.append('token', Session.get('token'))
      }
      // 获取基础 URL
      const baseExportUrl = process.env.VUE_APP_BASE_API + '/admin/user/export_view_analysis';
      // 拼接 URL 参数
      window.location.href = baseExportUrl + '?' + urlParams.toString()
    }
  },

  mounted() {
    this.setMaxHeight();
    window.addEventListener('resize', this.setMaxHeight);
    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setMaxHeight);
    // 组件销毁时移除监听事件
    window.removeEventListener('resize', this.handleResize);
  },
}
</script>
<style lang='scss' scoped>
.Box {}

.tableBox {
  width: 100%;
  margin-top: 10px;
}

.el-card__body {
  padding: 0px !important;
}

.btn_left {
  margin-left: 100px;
}

.div_buttom {
  width: 100%;
  display: flex;
  margin-bottom: 20px;
}

.btn {
  margin-top: 16px;
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
</style>